<template>
    <div class="col-12">

        <div class=" row text-center ml-5">
            <h3 class="ui inverted purple text"> <strong>Signature</strong></h3>
            <p class="text-muted fw-light mt-4">Insert your signature in the box below.</p>
        </div>

        <div class="row d-flex justify-content-center align-items-center mt-5">
            <div class="col-11 col-lg-9">

                <div class="row ml-5">
                    <div class="container">
                        <VueSignaturePad id="signature" width="100%" height="300px" ref="signaturePad" />
                    </div>

                </div>

                <div class="mt-5">
                    <button class="ui button  purple fluid mt-4" @click="save()" :disabled="isEmpty"
                        type="submit">Next</button>
                    <button class="ui button red fluid mt-4 mb-4" @click="clear()">Clear Signature</button>

                    <button class="ui button  grey fluid mt-4 mb-4" @click="back()">Back</button>
                </div>

            </div>
        </div>


    </div>
</template>
<script>
import baseMethods from "@/utils/baseMethods";
import { useAccountOpeningStore } from '@/stores/accountOpening';

export default {
    name: "Signature",
    setup() {
        const accountOpeningStore = useAccountOpeningStore();
        return { accountOpeningStore };
    },
    data() {
        return { count: 0 };
    },
    mounted() {
    },
    methods: {

        back() {
            this.$router.push("/omni/account-type");
        },

        undo() {
            this.$refs.signaturePad.undoSignature();
        },
        clear() {
            this.$refs.signaturePad.clearSignature();
        },
        save() {
            const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

            if (!isEmpty) {
                // Save signature to Vuex store
                this.setSignature(data);
                this.$router.push("/omni/upload-documents");
            }
        },
        submitForm() { },
        setSignature(data) { this.accountOpeningStore.setSignature(data); },
        ...baseMethods,
    }
};
</script>